<template lang="pug">
    v-form.c-form

        // Switch
        v-switch.c-switch(
            :label="$t('business.goals.consecutiveDays.switchLabel')"
            v-model="model.isActive"
            :disabled="isLoading"
            color="action"
            hide-details
        )

        div.params(v-if="model && model.isActive")
            div.param(
                v-for="(item, key) in $t('business.goals.consecutiveDays.params')"
                :key="`${key}-consecutive-days-param`"
            )
                div.placeholder

                v-checkbox.mt-1(
                    v-model="model.params[item.value]"
                    :label="item.label"
                    hide-details
                )
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapFields('goals', {
                model: 'consecutiveDays'
            }),
            ...mapGetters('goals', ['isLoading'])
        },
        watch: {
            ['model.isActive'](val, oldVal) {
                if (!val && oldVal) {
                    this.resetGoal('consecutiveDays');
                }
            }
        },
        methods: {
            ...mapActions('goals', ['resetGoal'])
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_variables.styl"

    .params
        margin-left: 12px
        padding-left: 12px

    .param
        display: flex
        align-items: center
        border-left: 1px solid rgba($theme.white, 0.5)

    .placeholder
        height: 1px
        width: 10px
        opacity: 0.5
        background-color: $theme.white
</style>
